import { render, staticRenderFns } from "./EducationSection.htm?vue&type=template&id=cf32bdd4&scoped=true&"
import script from "./EducationSection.ts?vue&type=script&lang=js&"
export * from "./EducationSection.ts?vue&type=script&lang=js&"
import style0 from "./EducationSection.scss?vue&type=style&index=0&id=cf32bdd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf32bdd4",
  null
  
)

export default component.exports